export const getVmUsers = item => item.tags?.users?.split(',') || [];
